import React, { useEffect } from "react";
import { useStore } from "./store.jsx";
import { BASE } from "./rutas.js";
import { Dashboard } from "./screens/dashboard.jsx";
import { Departments, Levels, Positions } from "./screens/orgchart.jsx";
import { OrgChart } from "./screens/orgchart-tree.jsx";
import { Factors } from "./screens/factors.jsx";
import { Scales } from "./screens/scales.jsx";
import { ValuationList, ValuationDetail } from "./screens/valuation.jsx";

/* ============================================================
   Talention — Página contenedora del SVPT embebido
   Subrouter de /svpt/*, estados de carga y error del espacio y chip de
   guardado. Todo lo del prototipo cuelga de <div className="svpt-root">,
   que es el ámbito de su CSS.
   ============================================================ */

const TEXTO_GUARDADO = {
  guardado: "Guardado",
  pendiente: "Cambios sin guardar…",
  guardando: "Guardando…",
  error: "Sin guardar",
  recargado: "Recargado desde el servidor",
};

/* Qué pantalla toca. El detalle va antes que la lista: si no, el prefijo
   se la comería. Una subruta desconocida cae en el dashboard. */
function Pantalla({ route }) {
  const sub = route.slice(BASE.length).replace(/^\//, "");
  if (sub.startsWith("valuation/")) return <ValuationDetail positionId={parseInt(sub.split("/")[1], 10)} />;
  if (sub.startsWith("valuation")) return <ValuationList />;
  if (sub.startsWith("orgchart")) return <OrgChart />;
  if (sub.startsWith("departments")) return <Departments />;
  if (sub.startsWith("levels")) return <Levels />;
  if (sub.startsWith("positions")) return <Positions />;
  if (sub.startsWith("factors")) return <Factors />;
  if (sub.startsWith("scales")) return <Scales />;
  return <Dashboard />;
}

function ChipGuardado() {
  const { guardado, guardadoError, reintentar } = useStore();
  const enError = guardado === "error";
  return (
    <div
      className={"svpt-guardado" + (enError ? " svpt-guardado-error" : "")}
      role="status"
      title={enError ? guardadoError || "" : undefined}
    >
      <span>{TEXTO_GUARDADO[guardado] || guardado}</span>
      {enError && (
        <button type="button" className="btn btn-ghost btn-sm" onClick={reintentar}>Reintentar</button>
      )}
    </div>
  );
}

function SvptPage({ route }) {
  const { carga, cargaError, activar, reintentarCarga } = useStore();

  // Carga perezosa: el espacio se pide la primera vez que se entra en el apartado.
  useEffect(() => { activar(); }, [activar]);

  if (carga === "error") {
    return (
      <div className="svpt-root">
        <div className="rb-card">
          <p className="rb-empty">{cargaError}</p>
          <button className="rb-btn rb-btn-primary" onClick={reintentarCarga}>Reintentar</button>
        </div>
      </div>
    );
  }

  if (carga !== "listo") {
    return <div className="svpt-root"><p className="rb-empty">Cargando el espacio de valoración…</p></div>;
  }

  return (
    <div className="svpt-root">
      <ChipGuardado />
      <Pantalla route={route} />
    </div>
  );
}

export { SvptPage };
